// extracted by mini-css-extract-plugin
export default {"canClick":"Breadcrumb_canClick__xawUP","icon":"Breadcrumb_icon__OXSrW","color":"Breadcrumb_color__O-phu"};